module.exports = __webpack_public_path__ + "img/favicon.bb74480c.png";